module.exports = __webpack_public_path__ + "img/rs_multigreyL-design.8f96203.png";